import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import Loader from '@/components/Loader/index.vue'
import FieldDatePortal from '@/components/edit/FieldDatePortal/index.vue'
import api from '@/helpers/fetch'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

@Component({
	components: {
		Loader,
		FieldDatePortal,
	},
})
export default class FieldPercentagePortal extends Vue {
	@Prop() type!: string
	@Prop() groupId!: number

	async mounted() {
		this.getReportFiles()
	}

	reportFiles: any[] = []
	forceUpdateKey = 0
	async getReportFiles() {
		const res = await api.get(`/api/reports/${this.groupId}/${this.type}`)
		this.reportFiles = res.reportFiles

		this.forceUpdateKey++
	}

	showingAll = false
	loadingAll = false
	async getAllReportFiles() {
		this.loadingAll = true
		const url = `/api/reports/${this.groupId}/${this.type}/${this.reportFiles.length}`
		const res = await api.get(url)
		const newReports = res.reportFiles

		this.reportFiles = [...this.reportFiles, ...newReports]
		this.loadingAll = false

		if (this.reportFiles.length >= res.count) {
			this.showingAll = true
		}

		this.forceUpdateKey++
	}

	loadingDateInput = {}
	key = 0
	async onDateInput(date, type, file) {
		const id = file.id
		file.date = date
		this.loadingDateInput[id] = 'loading'
		this.key++
		const res = await api.put('/api/reports', [{ date, id }])
		if (res.ok) {
			this.loadingDateInput[id] = 'success'
			this.key++
		}
	}

	async downloadFile($event, file) {
		const googleDriveId = file.googleDriveId
		const res = await fetch(
			'/api/reports/download?googleDriveId=' + googleDriveId,
			{
				headers: {
					Accept: 'application/pdf',
					'Content-Type': 'application/pdf',
				},
				method: 'GET',
				credentials: 'include',
			},
		)

		const headers = [...res.headers]
		const contentDispositionHeader = headers.find(
			(array) => array[0] === 'content-disposition',
		)
		if (contentDispositionHeader) {
			const fileName = contentDispositionHeader[1].replace(
				'attachment; filename=',
				'',
			)

			const blob = await res.blob()
			const newBlob = new Blob([blob])
			const blobUrl = window.URL.createObjectURL(newBlob)

			const link: any = document.createElement('a')
			link.href = blobUrl
			link.setAttribute('download', fileName)
			document.body.appendChild(link)

			if (link) {
				link.click()
				link.parentNode.removeChild(link)
				window.URL.revokeObjectURL(blobUrl)
			}
		}
	}

	maxLength(name) {
		const maxLength = 40
		const length = name.length
		if (length > maxLength) {
			const extensionArray = name.split('.')
			const extension = extensionArray[extensionArray.length - 1]
			return name.substr(0, maxLength) + '...' + extension
		}

		return name
	}

	fileToDelete: any = null
	setFileToDelete(file) {
		const that = this as any
		const $bvModal = that.$bvModal

		if ($bvModal) {
			$bvModal.show('modal-confirm-delete-report-files')
			this.fileToDelete = file
		}
	}

	deleting = false
	async deleteFile() {
		this.deleting = true
		const res = await fetch('/api/reports/' + this.fileToDelete.id, {
			method: 'DELETE',
			credentials: 'include',
		})

		this.deleting = false
		if (res.ok) {
			const that = this as any
			const $bvModal = that.$bvModal

			if ($bvModal) {
				$bvModal.hide('modal-confirm-delete-report-files')
				this.reportFiles = []
				this.getReportFiles()
			}
		}
	}
}
